/**
 * Client-side rules aligned with FlagModel: score and hint_penalty must not be below 0;
 * when both are set, hint_penalty must be less than score (score 0 allows only 0 or empty penalty).
 */
export function validateFlagScoreAndHintPenalty(
  scoreNum: number,
  hintPenaltyNum: number | null,
): Record<string, string> | null {
  if (!Number.isNaN(scoreNum) && scoreNum < 0) {
    return { score: 'Score cannot be less than 0.' };
  }
  if (hintPenaltyNum !== null && !Number.isNaN(hintPenaltyNum) && hintPenaltyNum < 0) {
    return { hint_penalty: 'Hint penalty cannot be less than 0.' };
  }
  if (
    hintPenaltyNum !== null &&
    !Number.isNaN(hintPenaltyNum) &&
    !Number.isNaN(scoreNum)
  ) {
    if (scoreNum === 0) {
      if (hintPenaltyNum > 0) {
        return {
          hint_penalty: 'When score is 0, hint penalty must be 0 or empty.',
        };
      }
    } else if (hintPenaltyNum >= scoreNum) {
      return { hint_penalty: 'Hint penalty must be less than score.' };
    }
  }
  return null;
}
